import { Ability, PureAbility } from '@casl/ability';
import { AbilityModule } from '@casl/angular';

import { NgModule, ModuleWithProviders } from '@angular/core';

import { SnAbilityGuard } from './guards';
import { ISnAbilityConfig } from './interfaces';
import { SN_ABILITY_CONFIG, snAbilityConfigFactory } from './providers';
import { SnAbilityService } from './services';

@NgModule({
  exports: [AbilityModule],
})
export class SnAbilityModule {
  public static forRoot(config?: Partial<ISnAbilityConfig>): ModuleWithProviders<SnAbilityModule> {
    return {
      ngModule: SnAbilityModule,
      providers: [
        SnAbilityGuard,
        SnAbilityService,
        { provide: Ability, useValue: new Ability() },
        { provide: PureAbility, useExisting: Ability },
        { provide: SN_ABILITY_CONFIG, useValue: snAbilityConfigFactory(config) },
      ],
    };
  }
}
